if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
      document.addEventListener('on:cart:add', (event) => {
        window.cartItems = event.detail.cart.items;
        let currentSku = this.getAttribute("data-sku");
        this.updateStockInfoViaSku(currentSku); // trigger to check ATC button status
      });
      document.addEventListener('on:line-item:change', (event) => {
        window.cartItems = event.detail.cart.items;
        let currentSku = this.getAttribute("data-sku");
        this.updateStockInfoViaSku(currentSku); // trigger to check ATC button status
      });

      document.addEventListener('click', function(e) {
        if (e.target.closest('.pickup-text a')) {
          e.preventDefault();
          
          if (document.querySelector('.js-inventory-locations-drawer')) {
            if (!document.querySelector('.js-inventory-locations-drawer.moved-to-body')) {
              document.body.appendChild(document.querySelector('.js-inventory-locations-drawer'));
            }
            document.querySelector('.js-inventory-locations-drawer').open();
          }
        }
      });

      // fetch all inventory items
      if (this.getAttribute("data-enable-stock-info") == 'true' && document.querySelector('.inventory-locations-item-ske')) {
        fetch(`https://luksusbaby-struct.apps.devtails.dk/frontend/get_locations`).then((response) => response.json()).then((locations) => {
          // console.log(locations)
          if (document.querySelector('.inventory-locations-drawer') && locations && locations.length) {
            let locationWrapper = document.querySelector('.inventory-locations-items');
            let excludeStores = this.getAttribute("data-exclude-stores") ? this.getAttribute("data-exclude-stores").split(',') : [];
            locations.forEach((location) => {
              let locationId = location.id;
              if (locationId.indexOf('/') >= 0) {
                locationId = locationId.split('/').pop();
              }
              if (excludeStores.includes(location.name)) {
                // this is for online store
                this.excludeStoreIds = this.excludeStoreIds || [];
                this.excludeStoreIds.push(locationId);
              } else {
                let ske = document.querySelector('.inventory-locations-item-ske').cloneNode(true);
                ske.querySelector('.location-name').innerText = location.name;
                ske.querySelectorAll('[data-location-id]').forEach((element) => {
                  element.setAttribute('data-location-id', `id_${locationId}`);
                });
                if (location.inventoryText) {
                  ske.querySelector('.location-inventory-text').innerHTML = location.inventoryText;
                  ske.querySelector('.location-inventory-text').removeAttribute('hidden');
                }
                let addressHTML = '';
                let address = location.address;
                if (address.address1) {
                  addressHTML += `<div>${address.address1}</div>`;
                }
                if (address.address2) {
                  addressHTML += `<div>${address.address2}</div>`;
                }
                if (address.city && address.zip) {
                  addressHTML += `<div>${address.zip} ${address.city}</div>`;
                }
                if (address.phone) {
                  addressHTML += `<div><a href="tel:${address.phone}">${address.phone}</a></div>`;
                }
                ske.querySelector('.location-address').innerHTML = addressHTML;
                ske.classList.remove('inventory-locations-item-ske');

                // hide location, setting: Theme settings > Location > Hide locations
                if (window.theme.hide_locations != '') {
                  const hideLocations = window.theme.hide_locations.split(',');
                  if (hideLocations.includes(location.name)) {
                    ske.classList.add('hidden');
                  }
                }

                // append to locationWrapper
                locationWrapper.appendChild(ske);
              }
            });
            // remove ske
            document.querySelector('.inventory-locations-item-ske').remove();
            
            // update stock info to each location
            this.updateStockInfoToLocation();
          }
        });
      } else {
        if (document.querySelector('#current-variant-inventory-online-store')) {
          window.currentProductInventoryOnline = JSON.parse(document.querySelector('#current-variant-inventory-online-store').textContent);
          let currentVariant = window.currentProductInventoryOnline[0];
          if (currentVariant) {
            this.setupStockQtyOnline(currentVariant);
          }
        }
      }
    }

    updateStockInfoToLocation() {
      let skus = this.getAttribute("data-skus");
      let currentSku = this.getAttribute("data-sku");
      fetch(`https://luksusbaby-struct.apps.devtails.dk/frontend/get_inventory_items?sku=${skus}`).then((response) => response.json()).then((json) => {
        // console.log(json)
        if (json['inventoryItems'] && json['inventoryItems'].length) {
          window.stockQty = window.stockQty || {};
          json['inventoryItems'].forEach((item) => {
            window.stockQty[item.sku] = item;
            if (item.sku == currentSku) {
              this.setupStockQty(item);
            }
          });
        }
      });
    }
    updateStockInfoViaSku(sku) {
      if (window.stockQty && window.stockQty[sku] && this.getAttribute("data-enable-stock-info") == 'true') {
        this.setupStockQty(window.stockQty[sku]);
      } else if (document.querySelector('#variant-inventory-online-store')) {
        window.currentProductInventoryOnline = JSON.parse(document.querySelector('#variant-inventory-online-store').textContent);
        window.currentProductInventoryOnline.forEach((v) => {
          if (v.sku == sku) {
            this.setupStockQtyOnline(v);
          }
        });
      }
    }

    setupStockQtyOnline(variant) {
      let stockStatus = '';
      let sku = variant.sku;
      if (variant.inventory_policy == 'continue' || variant.inventory_management == null) {
        stockStatus = 'instock';
      } else {
        if (variant.inventory_quantity > 4) {
          stockStatus = 'instock';
        } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 4) {
          stockStatus = 'lowstock';
        } else {
          stockStatus = 'outstock';
        }
      }
      let stockText = ''
      switch (stockStatus) {
        case 'outstock':
          stockText = this.getAttribute("data-online-outstock-text") || 'Out of stock';
          if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
            this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = stockText;
            this.querySelector(`[data-variant-sku="${sku}"]`).classList.remove('text-warning');
          }
          if (this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`)) {
            this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`).classList.remove('text-success');
            this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`).classList.add('text-error-text');
            this.querySelector(`[data-variant-sku="${sku}"].text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" width="18" height="18" class="icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
                <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
              </svg>`;
          }
          break;
        case 'lowstock':
          stockText = this.getAttribute("data-online-lowstock-text") || 'Only XX left';
          if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
            this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = stockText.replace('XX', variant.inventory_quantity);
            this.querySelector(`[data-variant-sku="${sku}"]`).classList.add('text-warning');
          }
          if (this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`)) {
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.add('text-success');
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.remove('text-error-text');
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
                <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
              </svg>`;
          }
          break;
        default:
          stockText = this.getAttribute("data-online-instock-text") || 'In stock';
          if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
            this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = stockText;
            this.querySelector(`[data-variant-sku="${sku}"]`).classList.remove('text-warning');
          }
          if (this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`)) {
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.add('text-success');
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.remove('text-error-text');
            this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
                <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
              </svg>`;
          }
      }
      if (this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`)) {
        this.querySelectorAll(`[data-variant-sku].text-with-icon`).forEach((element) => {
          if (sku != element.getAttribute('data-variant-sku')) {
            element.setAttribute('hidden', true);
          } else {
            element.removeAttribute('hidden');
          }
        });
      }
    }

    setupStockQty(item) {
      this.excludeStoreIds = this.excludeStoreIds || [];
      // loop item as key value 
      for (const [key, value] of Object.entries(item)) {
        // check if key start with id_
        if (key.startsWith('id_')) {
          let locationId = key.replace('id_', '');
          let sku = item.sku;
          if (this.excludeStoreIds.includes(locationId)) {
            // this is for online store
            let onlineStoreQty = 0;
            if (value && value.quantities && value.quantities[0] && value.quantities[0].quantity > 0 && item.tracked) {
              onlineStoreQty += value.quantities[0].quantity;
            }
            // console.log(onlineStoreQty)
            if (onlineStoreQty > 4) {
              let instockText = this.getAttribute("data-online-instock-text") || 'In stock';
              let posInstockText = this.getAttribute("data-pos-text-when-online-instock");
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = instockText;
                this.querySelector(`[data-variant-sku="${sku}"]`).classList.remove('text-warning');
              }
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`).innerHTML = posInstockText;
              }
              if (this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.add('text-success');
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.remove('text-error-text');
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
                    <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                    <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
                  </svg>`;
              }
            } else if (onlineStoreQty > 0 && onlineStoreQty <= 4) {
              let instockText = this.getAttribute("data-online-lowstock-text") || 'Only XX left';
              let posInstockText = this.getAttribute("data-pos-text-when-online-instock");
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = instockText.replace('XX', onlineStoreQty);
                this.querySelector(`[data-variant-sku="${sku}"]`).classList.add('text-warning');
              }
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`).innerHTML = posInstockText;
              }
              if (this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.add('text-success');
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon`).classList.remove('text-error-text');
                this.querySelector(`[data-variant-sku="${sku}"] .text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
                    <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                    <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
                  </svg>`;
              }
            } else {
              let outstockText = this.getAttribute("data-online-outstock-text") || 'Out of stock';
              let posOutstockText = this.getAttribute("data-pos-text-when-online-outstock");
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text`).innerText = outstockText;
                this.querySelector(`[data-variant-sku="${sku}"]`).classList.remove('text-warning');
              }
              if (this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`)) {
                this.querySelector(`[data-variant-sku="${sku}"] .online-store-stock-text ~ .pickup-text`).innerHTML = posOutstockText;
              }
              if (this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`)) {
                this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`).classList.remove('text-success');
                this.querySelector(`[data-variant-sku="${sku}"].text-with-icon`).classList.add('text-error-text');
                this.querySelector(`[data-variant-sku="${sku}"].text-with-icon svg`).outerHTML = `<svg role="presentation" focusable="false" width="18" height="18" class="icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
                    <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                    <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
                  </svg>`;
              }
            }
          } else {
            let elements = document.querySelectorAll(`.stock-text[data-location-id="${key}"]`);
            elements.forEach((element) => {
              if (value && value.quantities && value.quantities[0] && value.quantities[0].quantity > 0 && item.tracked) {
                // show instock content
                if (element.querySelector('.stock-value')) {
                  element.querySelector('.stock-value').innerText = value.quantities[0].quantity;
                }
                element.closest('.text-with-icon.instock-case')?.removeAttribute('hidden');
                element.closest('.text-with-icon.outstock-case')?.setAttribute('hidden', true);

                if (document.querySelector(`product-inventory [data-variant-sku="${item.sku}"] .pickup-text`)) {
                  document.querySelector(`product-inventory [data-variant-sku="${item.sku}"]`).removeAttribute('hidden');
                  document.querySelector(`product-inventory [data-variant-sku="${item.sku}"] .pickup-text`).removeAttribute('hidden');
                }
              } else {
                document.querySelector(`product-inventory [data-variant-sku="${item.sku}"]`)?.removeAttribute('hidden');
                element.closest('.text-with-icon.instock-case')?.setAttribute('hidden', true);
                element.closest('.text-with-icon.outstock-case')?.removeAttribute('hidden');
              }
            });
          }
          
        }
      }
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        // console.log(evt.detail.variant)
        this.querySelectorAll('[data-variant-sku]').forEach((element) => {
          element.setAttribute('hidden', true);
        });
        this.querySelectorAll('.pickup-text').forEach((element) => {
          element.setAttribute('hidden', true);
        });
        this.setAttribute("data-sku", evt.detail.variant["sku"]);
        this.updateStockInfoViaSku(evt.detail.variant["sku"]);
        if (document.querySelector('.inventory-locations-drawer .variant-title')) {
          document.querySelector('.inventory-locations-drawer .variant-title').innerText = evt.detail.variant["title"];
        }
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
